<script>
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'UploadPhoto',
  props: {
    uploadFor: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      image: null,
      photo: {
        name: "",
        image: null,
        date: new Date()
      }
    };
  },
  methods: {
    resetData() {
      this.image = null;
      this.photo = {
        name: "",
        image: null,
        date: new Date()
      }
    },
    ...mapActions("property", { uploadPropertyPhoto: "uploadPhoto" }),
    ...mapActions("area", { uploadAreaPhoto: "uploadPhoto" }),
    ...mapActions("item", { uploadItemPhoto: "uploadPhoto"}),
    setImage(bvModalEvt){
      this.photo.image = bvModalEvt.target.files[0];
    },
    emitPhotoUploaded() {
      this.$emit('photo-uploaded');
      this.resetData();
    },
    uploadPhoto(){
      if (!this.image) return;

      this.photo.name = this.image.name;
      const args = { file: this.photo, callback: this.emitPhotoUploaded }

      if(this.uploadFor == "property")
        this.uploadPropertyPhoto(args);
      else if(this.uploadFor == "area")
        this.uploadAreaPhoto(args);
      else if(this.uploadFor == "item")
        this.uploadItemPhoto(args);
    }
  },
  components: {
    DatePicker
  }
}
</script>
<template>
  <b-modal id="modal-addPhoto" title="Add Photo" @ok="uploadPhoto">
    <div>
      <form enctype="multipart/form-data" ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-file
          v-model="image"
          @change="setImage"
          :state="Boolean(image)"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        ></b-form-file>
        <div class="mt-3">Selected file: {{ image ? image.name : '' }}</div>
        <hr/>
        <div role="group" class="form-row form-group">
          <label for="text" class="col-lg-4 col-form-label">Date of Photo</label>
          <div class="col">
            <date-picker v-model="photo.date" format="MM/DD/YYYY"></date-picker>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>
